import styled from 'styled-components';

export const StyledDecaSpecialOffer = styled.div`
  width: 100%;
  max-width: 343px;
  height: 302px;
  font-family: var(--font-family), Arial;

  .container {
    height: 258px;
    background: linear-gradient(180deg, #2e3238 0%, #212529 100%);
    border-radius: 7px;
    margin-bottom: 4px;
    padding: 8px;

    .tooltip {
      margin-bottom: 4px;
    }

    .content {
      display: flex;
      width: 100%;

      .mainProductContainer {
        text-align: center;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 50%;
        height: inherit;
        display: flex;
        flex-direction: column;
        padding-right: 15px;

        .title {
          font-size: 12px;
          color: #eceaea;
          margin-bottom: 8px;
        }

        .subtitle {
          font-size: 10px;
          color: #fff;
        }

        .mainProduct {
          width: 100px;
          height: 100px;
          margin: auto auto 0;
          border-radius: 4px;
          padding: 2px;

          .product {
            padding: 0;

            .traits {
              margin: 0 6px;
            }
          }

          .backgroundSrc {
            max-height: 100px;
          }
        }

        .bottomContent {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 21px;
          margin-top: 8px;

          .timer {
            width: 76px;

            div {
              width: 100%;
              max-width: 68px;
            }
          }
          .availability {
            width: 68px;

            div {
              width: 100%;
              max-width: 60px;
            }
          }

          .timer,
          .availability {
            text-align: center;
            height: 21px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            color: #eceaea;
            border-radius: 4px;
            background: #171a1c;
            box-shadow: 0px -1px 0px 0px #2c3036 inset;
            padding: 6px 4px;
          }
        }
      }

      .subProductsContainer {
        background: #171a1c;
        border-radius: 4px;
        padding: 12px 3px 0px 8px;
        height: 222px;
        width: 50%;

        &__scroll {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          overflow-y: scroll;
          padding-right: 3px;

          /* --- WebKit (Chrome, Safari, Edge) --- */
          &::-webkit-scrollbar {
            width: 1px;
          }

          &::-webkit-scrollbar-thumb {
            background: #fff;
            border-radius: 1px;
          }
        }
      }
    }
  }

  .price {
    border-radius: 7px;

    .final-price {
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-shadow: none;
    }

    .stroked {
      font-size: 10px;
      color: #eceaea;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;

export const StyledSubProduct = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #23272c;
  padding: 3px 0;

  .image {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;

    img {
      width: auto;
      height: 100%;
      max-height: 24px;
      object-fit: contain;
    }
  }

  .quantity {
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
